import it from './locales/it.json'

export default {
  it,
}